(function () {
    function parseVariantData(sectionElement) {
        var jsonElement = sectionElement.querySelector('[data-product-variants-json]');

        if (!jsonElement) {
            return null;
        }

        try {
            return JSON.parse(jsonElement.textContent);
        } catch (error) {
            console.warn('Vitalify product variants JSON could not be parsed.', error);
            return null;
        }
    }

    function findVariant(variants, selectedOptions) {
        return variants.find(function (variant) {
            return variant.options.every(function (value, index) {
                return selectedOptions[index] === value;
            });
        });
    }

    function setActiveThumb(sectionElement, mediaId) {
        var thumbs = sectionElement.querySelectorAll('[data-product-gallery-thumb]');

        thumbs.forEach(function (thumb) {
            thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-id')) === String(mediaId));
        });
    }

    function emitVariantChange(sectionElement, variant) {
        document.dispatchEvent(new CustomEvent('vitalify:variant:change', {
            detail: {
                productId: sectionElement.getAttribute('data-product-id'),
                variant: variant
            }
        }));
    }

    function updateVariantUI(sectionElement, variant) {
        var variantInput = sectionElement.querySelector('[data-product-variant-id]');
        var priceElement = sectionElement.querySelector('[data-product-price]');
        var pixPriceElement = sectionElement.querySelector('[data-product-pix-price]');
        var installmentPriceElement = sectionElement.querySelector('[data-installments-price]');
        var comparePriceElement = sectionElement.querySelector('[data-product-compare-price]');
        var submitButton = sectionElement.querySelector('[data-product-submit]');
        var submitLabel = sectionElement.querySelector('[data-product-submit-label]');
        var buttonLabel = sectionElement.getAttribute('data-button-label') || 'COMPRAR';
        var soldOutLabel = sectionElement.getAttribute('data-sold-out-label') || 'Sem estoque';

        if (variantInput) {
            variantInput.value = variant.id;
        }

        if (priceElement) {
            priceElement.textContent = variant.priceFormatted;
        }

        if (pixPriceElement && variant.pixPriceFormatted) {
            pixPriceElement.innerHTML = '<strong>' + variant.pixPriceFormatted + '</strong> com Pix';
        }

        if (installmentPriceElement && variant.installmentPriceFormatted) {
            installmentPriceElement.textContent = variant.installmentPriceFormatted;
        }

        if (comparePriceElement) {
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                comparePriceElement.hidden = false;
                comparePriceElement.textContent = variant.compareAtPriceFormatted;
            } else {
                comparePriceElement.hidden = true;
                comparePriceElement.textContent = '';
            }
        }

        if (submitButton && submitLabel) {
            submitButton.disabled = !variant.available;
            submitLabel.textContent = variant.available ? buttonLabel : soldOutLabel;
        }

        if (variant.featuredMediaId) {
            setActiveThumb(sectionElement, variant.featuredMediaId);
        }

        emitVariantChange(sectionElement, variant);
    }

    function bindQuantity(sectionElement) {
        if (!sectionElement || sectionElement.dataset.quantityBound === 'true') {
            return;
        }

        sectionElement.dataset.quantityBound = 'true';

        sectionElement.addEventListener('click', function (event) {
            var decreaseButton = event.target.closest('[data-quantity-decrease]');
            var increaseButton = event.target.closest('[data-quantity-increase]');

            if (!decreaseButton && !increaseButton) {
                return;
            }

            var quantityPicker = event.target.closest('[data-quantity-picker]');
            var input = quantityPicker ? quantityPicker.querySelector('[data-quantity-input]') : null;

            if (!input) {
                return;
            }

            var min = Number(input.getAttribute('min') || '1');
            var currentValue = Number(input.value || min);
            var nextValue = increaseButton ? currentValue + 1 : currentValue - 1;

            input.value = Math.max(min, nextValue);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    function initGallery(sectionElement) {
        var sliderElement = sectionElement.querySelector('[data-product-gallery-slider]');
        var thumbButtons = sectionElement.querySelectorAll('[data-product-gallery-thumb]');

        if (!sliderElement) {
            return null;
        }

        if (sectionElement.dataset.galleryInitialized === 'true') {
            return sectionElement._vitalifyProductGallerySlider || null;
        }

        var sliderInstance = window.VitalifySwiper ? window.VitalifySwiper.create(sliderElement, {
            slidesPerView: 1,
            spaceBetween: 16
        }) : null;

        if (!sliderInstance) {
            return null;
        }

        sectionElement.dataset.galleryInitialized = 'true';
        sectionElement._vitalifyProductGallerySlider = sliderInstance;

        thumbButtons.forEach(function (thumbButton, index) {
            thumbButton.addEventListener('click', function () {
                if (sliderInstance) {
                    sliderInstance.slideTo(index);
                }

                setActiveThumb(sectionElement, thumbButton.getAttribute('data-media-id'));
            });
        });

        if (sliderInstance) {
            sliderInstance.on('slideChange', function () {
                var activeSlide = sliderElement.querySelectorAll('.swiper-slide')[sliderInstance.activeIndex];

                if (activeSlide) {
                    setActiveThumb(sectionElement, activeSlide.getAttribute('data-media-id'));
                }
            });
        }

        return sliderInstance;
    }

    function initGalleryModal(sectionElement) {
        var modalElement = sectionElement.querySelector('[data-product-gallery-modal]');
        var sliderElement = sectionElement.querySelector('[data-product-gallery-modal-slider]');
        var openButtons = sectionElement.querySelectorAll('[data-product-gallery-open]');
        var closeButtons = sectionElement.querySelectorAll('[data-product-gallery-modal-close]');
        var previousButton = sectionElement.querySelector('[data-product-gallery-modal-prev]');
        var nextButton = sectionElement.querySelector('[data-product-gallery-modal-next]');
        var modalSlider = null;
        var lastFocusedElement = null;

        if (!modalElement || !sliderElement || !openButtons.length) {
            return;
        }

        if (modalElement.dataset.initialized === 'true') {
            return;
        }

        function ensureModalSlider() {
            if (modalSlider || !window.VitalifySwiper) {
                return;
            }

            modalSlider = window.VitalifySwiper.create(sliderElement, {
                slidesPerView: 1,
                spaceBetween: 18,
                navigation: previousButton && nextButton ? {
                    prevEl: previousButton,
                    nextEl: nextButton
                } : undefined
            });
        }

        ensureModalSlider();

        function openModal(index) {
            ensureModalSlider();
            lastFocusedElement = document.activeElement;
            modalElement.hidden = false;
            modalElement.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
            modalElement.offsetHeight;
            modalElement.classList.add('is-open');

            if (modalSlider) {
                modalSlider.slideTo(index || 0, 0);
                modalSlider.update();
            }

            var closeButton = modalElement.querySelector('.vitalify-product-gallery-modal__close');

            if (closeButton) {
                closeButton.focus();
            }
        }

        function closeModal() {
            modalElement.classList.remove('is-open');
            modalElement.setAttribute('aria-hidden', 'true');
            document.documentElement.style.overflow = '';

            window.setTimeout(function () {
                if (!modalElement.classList.contains('is-open')) {
                    modalElement.hidden = true;
                }
            }, 220);

            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                lastFocusedElement.focus();
            }
        }

        openButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                openModal(Number(button.getAttribute('data-media-index') || '0'));
            });
        });

        closeButtons.forEach(function (button) {
            button.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && modalElement.classList.contains('is-open')) {
                closeModal();
            }
        });

        modalElement.dataset.initialized = 'true';
    }

    function bindDetailTabs(sectionElement) {
        var tabButtons = sectionElement.querySelectorAll('[data-detail-tab]');
        var panels = sectionElement.querySelectorAll('[data-detail-panel]');

        if (!tabButtons.length || !panels.length) {
            return;
        }

        tabButtons.forEach(function (tabButton) {
            tabButton.addEventListener('click', function () {
                var targetId = tabButton.getAttribute('data-target');

                tabButtons.forEach(function (button) {
                    button.classList.toggle('is-active', button === tabButton);
                    button.setAttribute('aria-selected', button === tabButton ? 'true' : 'false');
                });

                panels.forEach(function (panel) {
                    var isTarget = panel.id === targetId;
                    panel.hidden = !isTarget;
                    panel.classList.toggle('is-active', isTarget);
                });
            });
        });
    }

    function initProductHero(sectionElement) {
        if (!sectionElement) {
            return;
        }

        if (sectionElement.dataset.initialized === 'true') {
            initGallery(sectionElement);
            initGalleryModal(sectionElement);
            bindQuantity(sectionElement);
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var data = parseVariantData(sectionElement);
        var sliderInstance = initGallery(sectionElement);
        var optionInputs = sectionElement.querySelectorAll('[data-product-option-input]');

        bindDetailTabs(sectionElement);
        initGalleryModal(sectionElement);
        bindQuantity(sectionElement);

        if (!data || !data.variants || !data.variants.length) {
            return;
        }

        function getSelectedOptions() {
            var selected = [];
            var groups = sectionElement.querySelectorAll('.vitalify-product-form__option-group');

            groups.forEach(function (group) {
                var checked = group.querySelector('[data-product-option-input]:checked');
                selected.push(checked ? checked.value : '');
            });

            return selected;
        }

        optionInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                var selectedOptions = getSelectedOptions();
                var variant = findVariant(data.variants, selectedOptions);

                if (variant) {
                    updateVariantUI(sectionElement, variant);

                    var activeSlider = sectionElement._vitalifyProductGallerySlider || sliderInstance;

                    if (variant.featuredMediaId && activeSlider) {
                        var slides = sectionElement.querySelectorAll('.vitalify-product-gallery__slide');

                        slides.forEach(function (slide, index) {
                            if (String(slide.getAttribute('data-media-id')) === String(variant.featuredMediaId)) {
                                activeSlider.slideTo(index);
                            }
                        });
                    }
                }
            });
        });

        var currentVariantId = sectionElement.getAttribute('data-current-variant-id');
        var initialVariant = data.variants.find(function (variant) {
            return String(variant.id) === String(currentVariantId);
        }) || data.variants[0];

        updateVariantUI(sectionElement, initialVariant);
    }

    window.VitalifyProductHero = {
        init: initProductHero
    };
})();
